import styled from 'styled-components';
import Button from 'app/commonComponents/Button';
import { colors } from 'app/variables';
import { media } from 'app/utils/style';

export const ButtonBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${colors.white};
  border-top: 1px solid ${colors.gallery};
  padding: 1rem 1.5rem 0.75rem 1.5rem;
  margin: ${({ $isSingleButton }) =>
    $isSingleButton ? 'auto auto 0 auto' : 'auto 0 0 0'};

  position: sticky;
  bottom: 0;

  ${media.mediumHigh`
    margin-top: initial;
    position: relative;
  `}

  ${media.mediumDesktop`
    border: none;
    width: 100%;
    padding: 0 0 1rem 0;
  `}
`;
export const Privacy = styled.div`
  display: block;
  font-size: 0.75rem;
  width: 100%;

  padding: 0 0.5rem 0.75rem 0.5rem;

  // styling for the links inside the translated string, inserted as innerhtml
  & a {
    color: ${colors.pacificBlue};
    text-decoration: none;
  }

  ${media.mediumDesktop`
    padding: 0.5rem;
  `}
`;
export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
export const BackButton = styled.button`
  font-size: 1rem;
  background: initial;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${colors.pacificBlue};
  padding: 0.5rem;
  border-radius: 10px;

  ${media.mediumDesktop`
    display: ${({ $hideOnDesktopView }) => $hideOnDesktopView && 'none'};
  `}

  &:focus {
    filter: brightness(1.15);
    outline: 1px solid ${colors.pacificBlue};
    box-shadow: 0 0 0.25rem ${colors.pacificBlue};
  }
`;

export const ContinueButton = styled(Button)`
  border-radius: 10px;
  ${media.mediumDesktop`
    width: ${({ $fullWidthOnDesktopView }) => $fullWidthOnDesktopView && '100%'};
  `}

  &:focus {
    filter: brightness(1.15);
    outline: 1px solid ${colors.pacificBlue};
    box-shadow: 0 0 0.25rem ${colors.pacificBlue};
  }
`;
